<mat-table #table [dataSource]="dataSource" multiTemplateDataRows matSortDisableClear matSort id="tblDesignPages"
    matSortActive="" matSortDirection="desc" *ngIf="!designPageId">
    <ng-container matColumnDef="More">
        <mat-header-cell *matHeaderCellDef>
            <span *ngIf="dataSource && dataSource.data.length > 0" class="material-icons" [ngClass]="{
          'detail-row-expanded-icon': rowsExpanded,
          'detail-row-collapsed-icon': !rowsExpanded}" (click)="expandCollapseAll()"></span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
            <span aria-label="Expand row for more details" *ngIf="element.HasDetailRows">
                <i [ngClass]="dataSource.checkExpanded(element) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                    aria-hidden="true"></i>
            </span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Page Name </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.Name}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="ObjectName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Page Type </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.ObjectName}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="ModuleName">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Module </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.ModuleName}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="BasePage">
        <mat-header-cell *matHeaderCellDef mat-sort-header> User Defined Page </mat-header-cell>
        <mat-cell *matCellDef="let element" style="display:flex; justify-content:center;">
            <span *ngIf="element.BasePage">Y</span>
            <span *ngIf="!element.BasePage"></span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Status">
        <mat-header-cell *matHeaderCellDef mat-sort-header><span translate>Active</span></mat-header-cell>
        <mat-cell *matCellDef="let element" style="display:flex; justify-content:center;">
            <span *ngIf="element.Active">Y</span>
            <span *ngIf="!element.Active"></span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Actions">
        <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex;">
            <!-- <tyl-mat-menu id="tblCustomFieldsActionMenu{{i}}" image="actions.png" [iconWidth]="30" *ngIf="allowViewEdit">
                <button id="view{{i}}" aria-label="View Page" mat-menu-item class="menuItem" (click)="viewClick(element)"
                    *ngIf="allowViewEdit">View</button>
                <mat-divider></mat-divider>
                <button id="edit{{i}}" aria-label="Edit Page" mat-menu-item class="menuItem" (click)="editClick(element)"
                    *ngIf="userCanEdit && devMode && allowViewEdit">Edit</button>
                <mat-divider *ngIf="allowViewEdit && userCanEdit && !element.Active"></mat-divider>
                <button id="revert{{i}}" aria-label="Revert to system-defined version" mat-menu-item class="menuItem" (click)="revertClick(element)"
                    *ngIf="userCanEdit && !element.Active">Activate</button>
            </tyl-mat-menu>
            <a id="activate{{i}}" aria-label="Activate the default version" *ngIf="!allowViewEdit && userCanEdit && !element.Active" (click)="revertClick(element)">Activate</a> -->
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
        <mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplay.length" style="width:100%;"
            class="mat-detail-card">
            <div style="display: flex; flex-direction: column;width: 100%;">
                <design-page-details [userDefinedPages]="element.DesignPageID | cstUserDesignPagesByID: allDesignPages"
                    [designPageID]="element.DesignPageID" [userCanEdit]="userCanEdit" [allowViewEdit]="allowViewEdit"
                    (updateBasePageEvent)="getDesignPages()" (designPageUpdated)="designPageUpdatedHandler()"></design-page-details>
            </div>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: columnsToDisplay; let i = renderIndex;" id="tblCustomFieldsDataRow{{i}}"
        [ngStyle]="{'border-bottom-width':dataSource.checkExpanded(row) && row.HasDetailRows ? '0px' : '1px'}"
        style="padding:0px;overflow: hidden;" matRipple (click)="dataSource.toggleExpanded(row)"
        (keydown)="dataSource.rowKeyPress($event, row)">
    </mat-row>
    <mat-row *matRowDef="let row; columns: ['expandedDetail']"
        [@detailExpand]="dataSource.checkExpanded(row) && row.HasDetailRows ? 'expanded' : 'collapsed'"
        style="overflow: hidden;" class="mat-detail-row">
    </mat-row>

</mat-table>
<design-page-details [userDefinedPages]="allDesignPages" [designPageID]="designPageId" [singlePageMode]="true"
    [userCanEdit]="userCanEdit" [allowViewEdit]="allowViewEdit" (updateBasePageEvent)="getDesignPages()"
    (designPageUpdated)="designPageUpdatedHandler()" *ngIf="designPageId"></design-page-details>